import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  background-color: #F0F0F0;
  border: 1px solid #F0F0F0;
  &.hidden {
    display: none;
  }
`

const Grey = ({children, hidden}) => {
  return (
    <Container className={hidden ? 'hidden' : 'visible'}>
      {children}
    </Container>
  )
}

export default Grey
